/** "Fijar sidebar" (queda expandido siempre, no sólo con hover/foco),
 *  persistido en localStorage. Mismo patrón que theme.ts/columnPreferences.ts:
 *  degrada a `false` en vez de romper si localStorage no está disponible
 *  (modo privado, por ejemplo).
 */

import { useState } from 'react'

const STORAGE_KEY = 'deltabot:sidebar-pinned'

function load(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

function save(pinned: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(pinned))
  } catch {
    // Ídem load(): si no se puede guardar, el botón sigue andando sin memoria.
  }
}

export function useSidebarPin(): [boolean, () => void] {
  const [pinned, setPinned] = useState<boolean>(load)

  return [
    pinned,
    () =>
      setPinned((current) => {
        const next = !current
        save(next)
        return next
      }),
  ]
}
